import { StanToggle } from '@/components';
import { createIconElement } from '@/lib/utils/createIconElement';
import IconHelp from '@/assets/icons/ic-help-circle.svg';
import IconAlertCircle from '@/assets/icons/ic-alert-circle.svg';

interface TaxToggleHeaderProps {
    enabled: boolean;
    loading: boolean;
    hasTaxIssue: boolean;
    onToggle: (enabled: boolean) => void;
}

export const TaxToggleHeader = ({ enabled, loading, hasTaxIssue, onToggle }: TaxToggleHeaderProps) => (
    <>
        <div className='mb-4'>
            <div className='mb-0 flex items-center gap-2'>
                <h4>Enable Taxes</h4>
                <StanToggle
                    checked={enabled}
                    onChange={e => onToggle(e.target.checked)}
                    disabled={loading}
                    toggleSize='sm'
                />
            </div>
            <p className='text-caption-1-regular text-gray mt-1'>
                Automatically calculate and collect tax on your payments.{' '}
                <a
                    href='https://help.stan.store/article/204-collecting-sales-tax-with-stan'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-brand-main'
                >
                    {createIconElement(IconHelp, { className: 'inline size-4' })}
                </a>
            </p>
        </div>

        {enabled && hasTaxIssue && <TaxIssueWarning />}
    </>
);

const TaxIssueWarning = () => (
    <div className='bg-warning-subtle mb-6 flex items-start gap-2 rounded-lg p-4'>
        {createIconElement(IconAlertCircle, { className: 'text-warning-dark mt-0.5 size-5' })}
        <p className='text-body-sm'>
            Uh oh! We need more information to collect taxes in your area. Please contact us at{' '}
            <a href='mailto:friends@stanwith.me' className='text-brand-main font-bold'>
                friends@stanwith.me
            </a>
            .
        </p>
    </div>
);
